import { Injectable } from '@angular/core';
import { Employee } from '@monorepo-projects/absence-shared';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  public employeesByYear: { year: number; employees: Employee[] }[] = [];
  public employeesInfByYear: { year: number; employees: Employee[] }[] = [];

  public setEmployees(year: number, employees: Employee[], inf: boolean) {
    const data = this.getEmployeesByYear(year, inf);
    if (data) {
      return;
    }
    if (inf) {
      this.employeesInfByYear.push({ year: year, employees: employees });
      return;
    }
    this.employeesByYear.push({ year: year, employees: employees });
  }

  public getEmployeesByYear(year: number, inf: boolean) {
    if (inf) {
      return this.employeesInfByYear.find((e) => e.year === year);
    }
    return this.employeesByYear.find((e) => e.year === year);
  }
}
